import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router, RouterModule } from '@angular/router';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-tanker-pre-regestration',

  templateUrl: './tanker-pre-regestration.component.html',

  styleUrls: ['./tanker-pre-regestration.component.css'],

})

export class TankerPreRegestrationComponent implements OnInit {

  private persianRegex = /^[\u0600-\u06FF\s]$/;

  lst_Result: any = [];

  lst_Search: any = [];

  lst_Installer: any = [];

  lst_Installation_Status = [];

  lst_State = [];

  lst_City = [];

  lst_Visitor = [];

  list_Checked: any = [];

  lst_Status: any = [];

  bEditMode: boolean = false;

  showFilter: boolean = false;

  bMapInput: boolean = false;

  isHubConnect: boolean = false;

  acssess: any;

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iSystemUser_Visitor: new FormControl('-1'),

    strSInstallDate: new FormControl(''),

    strEInstallDate: new FormControl(''),

    strSRegisterDate: new FormControl(''),

    strERegisterDate: new FormControl(''),

    strCity: new FormControl(''),

    strState: new FormControl(''),

    tiInstallationStatus: new FormControl('-1'),

    iInstaller: new FormControl('-1'),

    strMobile: new FormControl(''),

  });

  mdl_Schedule: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strInstallDate: new FormControl('', Validators.required),

    strInstallTime: new FormControl('', Validators.required),

    lstiPreregistration: new FormControl([]),

  });

  mdl_Select_Installer: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iInstaller: new FormControl('', Validators.required),

    lstiPreregistration: new FormControl([], Validators.required),

  });

  mdl_Status: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    tiInstallationStatus: new FormControl(null, Validators.required),

    lstiPreregistration: new FormControl([], Validators.required),

  });

  mdl_SMS: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strSMS: new FormControl('', Validators.required),

    lstiPreregistration: new FormControl([], Validators.required),

  });

  mdl_SMS_Installer: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strSMS: new FormControl('', Validators.required),

    lstiPreregistration: new FormControl([], Validators.required),

  });

  mdl_Request: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strFamily: new FormControl({ value: '', disabled: true }),

    strMobile: new FormControl({ value: '', disabled: true }),

    strMobile1: new FormControl({ value: '', disabled: true }),

    strInstaller_strFullName: new FormControl({ value: '', disabled: true }),

    strID: new FormControl({ value: '', disabled: true }),

    strComment: new FormControl({ value: '', disabled: true }),

    strInstallerComment: new FormControl({ value: '', disabled: true }),

    strGPSType: new FormControl({ value: '', disabled: true }),

    strLicenseNo: new FormControl({ value: '', disabled: true }),

    strInstallationStatus: new FormControl({ value: '', disabled: true }),

    iTrackingCode: new FormControl({ value: '', disabled: true }),

    strLicenseImage: new FormControl(''),

    strStateName: new FormControl({ value: '', disabled: true }),

    strState: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    strCityName: new FormControl({ value: '', disabled: true }),

    iPreregistration: new FormControl(''),

    tiInstallationStatus: new FormControl('', Validators.required),

    strAddress: new FormControl('', Validators.required),

    fLat: new FormControl('', Validators.required),

    fLon: new FormControl('', Validators.required),

    bHas12DC: new FormControl(false),

    plak4: new FormControl('', [Validators.required, Validators.maxLength(2), Validators.pattern(/^[1-9][0-9]$/)]),

    plak3: new FormControl('', [Validators.required, Validators.maxLength(3), Validators.pattern(/^[1-9][0-9][0-9]$/)]),

    plak2: new FormControl('', [Validators.required]),

    plak1: new FormControl('', [Validators.required, Validators.maxLength(2), Validators.pattern(/^[1-9][0-9]$/)]),

    lstiPreregistration: new FormControl([], Validators.required),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this._gurd.decrypt(data));

    this.initialize();

    this.mdl_Search.patchValue({

      // strMobile: '09015801728'

    });


  }

  ngAfterContentChecked() {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  initialize = async () => {

    await this.getInstaller();

    await this.get_Installation_Status();

    await this.get_State();

    await this.get_Visitor();

    await this.get_StatusList();

  }

  getInstaller = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Installer_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Installer = res;

  }

  get_Installation_Status = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`InstallationStatus_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Installation_Status = res;

  }

  get_State = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Shilatnegar_State_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_State = res;

  }

  get_Visitor = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_Visitor_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Visitor = res;

  }

  get_StatusList = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`InstallationStatus_List4Managment`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z1@1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Status = res;

    // strInstallationStatus:"واریز وجه";

    // tiInstallationStatus:1;

  }

  getCity = async (state) => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Shilatnegar_City_List4State?strState=${state}`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_City = res;

  }

  filter_Result(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strSGeoFence_strTitle.includes(val.value) ||

        el.strSystemUser_strFullName?.includes(val.value) ||

        el.strDGeoFence_strTitle.includes(val.value)
    });

    if (val.value.length == 0) {

      this.lst_Result = this.lst_Search;

    }

  }

  getList = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_Search`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

    this.list_Checked = [];

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'پیش ثبت‌نام ها.xlsx');
  }

  showCluster() {

    if (!this.lst_Result.length) return this._tooltip.showError('نتیجه ایی یافت نشد!');

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this._gurd.encrypt(JSON.stringify(this.lst_Result)));

    window.open('/emdadran/search-requests/map', '_blank')

  }

  selectAllCheckBox() {

    if (this.lst_Result.length > 0 && (this.lst_Result.length != this.list_Checked.length)) {

      this.list_Checked = [];

      this.lst_Result.forEach((a: any) => {

        this.list_Checked.push(a.iPreregistration);

      })

      this._tooltip.showSuccess('همه انتخاب شدند')

    }

    else {

      this.list_Checked = [];

    }

  }

  isSelected(item: any): boolean {

    return this.list_Checked.indexOf(item) !== -1;

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.list_Checked.push(item.iPreregistration);

    else {

      this.list_Checked.find((value: any) => {

        if (value === item.iPreregistration) {

          const index = this.list_Checked.indexOf(item.iPreregistration);

          if (index !== -1) this.list_Checked.splice(index, 1);

        }

      })

    }

  }

  setSchedule = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    this.mdl_Schedule.patchValue({

      strInstallDate: '',

      strInstallTime: '',

      lstiPreregistration: this.list_Checked,

    })

    this._other.markAllAsUnTouched(this.mdl_Schedule);

    $("#schedule_Modal").modal('show');

  }

  submit_Schedule = async () => {

    this._other.markAllAsTouched(this.mdl_Schedule);

    this.mdl_Schedule.patchValue({

      strInstallTime: $("#strInstallTime").val(),

    })

    if (this.mdl_Schedule.invalid) {

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید')

    }

    let model = this.mdl_Schedule.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SetInstallationTime`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#schedule_Modal").modal('hide');


  }

  chooseInstaller = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    this.mdl_Select_Installer.patchValue({

      iInstaller: null,

      lstiPreregistration: this.list_Checked,

    })

    this._other.markAllAsUnTouched(this.mdl_Select_Installer);

    $("#installer_Modal").modal('show');

  }

  submit_Installer = async () => {

    this._other.markAllAsTouched(this.mdl_Select_Installer);

    if (this.mdl_Select_Installer.invalid) {

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید')

    }

    let model = this.mdl_Select_Installer.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SetInstaller`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#installer_Modal").modal('hide');


  }

  open_UpdateStatus = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    this.mdl_Status.patchValue({

      tiInstallationStatus: null,

      lstiPreregistration: this.list_Checked,

    });

    this._other.markAllAsUnTouched(this.mdl_Status);

    $("#status_Modal").modal('show');

  }

  submit_Status = async () => {

    this._other.markAllAsTouched(this.mdl_Status);

    if (this.mdl_Status.invalid) {

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید')

    }

    let model = this.mdl_Status.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SetInstallationStatus`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z-1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#status_Modal").modal('hide');

  }

  open_Send_SMS = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    this.mdl_SMS.patchValue({

      strSMS: '',

      lstiPreregistration: this.list_Checked,

    });

    this._other.markAllAsUnTouched(this.mdl_SMS);

    $("#sendSms_Modal").modal('show');

  }

  submit_Sms = async () => {

    this._other.markAllAsTouched(this.mdl_SMS);

    if (this.mdl_SMS.invalid) {

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید')

    }

    let model = this.mdl_SMS.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SendSMS`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z[1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#sendSms_Modal").modal('hide');

  }

  open_Send_SMSInstaller = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    this.mdl_SMS_Installer.patchValue({

      strSMS: '',

      lstiPreregistration: this.list_Checked,

    });

    this._other.markAllAsUnTouched(this.mdl_SMS_Installer);

    $("#sendSmsInstaller_Modal").modal('show');

  }

  submit_SmsInstaller = async () => {

    this._other.markAllAsTouched(this.mdl_SMS_Installer);

    if (this.mdl_SMS_Installer.invalid) {

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید')

    }

    let model = this.mdl_SMS_Installer.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SendSMS2Installer`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z[1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('با موفقیت ثبت شد');

    $("#sendSmsInstaller_Modal").modal('hide');

  }

  open_Info = async (item: any, index: number) => {

    let model = this._other.stringNumberToNumber({

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iPreregistration: item.iPreregistration

    })

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_Info4Admin`, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zxa10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    Object.keys(res[0]).forEach((key => {

      this.mdl_Request.patchValue({ [key]: res[0][key] })

    }));

    this.list_Checked = [];

    this.list_Checked.push(item.iPreregistration);

    $("#requestInfo_Modal").modal("show");

  }

  open_Edit = async (item: any, index: number) => {

    let model = this._other.stringNumberToNumber({

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iPreregistration: item.iPreregistration

    })

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_Info4Admin`, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zxa10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    Object.keys(res[0]).forEach((key => {

      this.mdl_Request.patchValue({ [key]: res[0][key] })

    }));

    this.getCity(item.strState);

    this.buildVehicleNo(item);

    // rerender custom-map

    this.bMapInput = false;

    setTimeout(() => {

      this.bMapInput = true;

    }, 10);

    this.mdl_Request.get('strComment')?.enable();

    this.list_Checked = [];

    this.list_Checked.push(item.iPreregistration);

    this.mdl_Request.patchValue({

      lstiPreregistration: this.list_Checked,

    });


    $("#editRequest_Modal").modal("show");

  }

  submitData(value: any) {

    // اگر کاربر متنی را به آدرس اضافه کرد

    if (value.isChanged == true) {

      this.mdl_Request.controls['strAddress'].setValue(value.strText);

    }

    // اگر کاربر از روی نقشه موقعیت را انتخاب کرد

    else {

      this.mdl_Request.controls['fLat'].setValue(value.latitude);

      this.mdl_Request.controls['fLon'].setValue(value.longitude);

      this.mdl_Request.controls['strAddress'].setValue(value.strText_Toolbar);

      // Rerender custom-map

      this.bMapInput = false;

      setTimeout(() => {

        this.bMapInput = true;

      }, 10);

    }

  }

  viewFullScreen() {

    const base64 = this.mdl_Request.get('strLicenseImage').value;

    const byteCharacters = atob(base64);

    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {

      byteNumbers[i] = byteCharacters.charCodeAt(i);

    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'image/jpeg' });

    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');

  }

  sendPaymentLink = async () => {

    if (!this.list_Checked.length) {

      return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    }

    let model = this._other.stringNumberToNumber({

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      lstiPreregistration: this.list_Checked,

    })

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Preregistration_SMSPaymentLink`, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z[1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this._tooltip.showSuccess('با موفقیت انجام شد');

  }

  onlyNumber(e: KeyboardEvent) {

    if (e.ctrlKey || e.metaKey || /[0-9]/.test(e.key) || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {

      return;

    }

    e.preventDefault();
  }

  onlyPersian(e: KeyboardEvent) {

    const controlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End'
    ];

    if (e.ctrlKey || e.metaKey || controlKeys.includes(e.key)) {
      return;
    }

    if (!this.persianRegex.test(e.key)) {

      e.preventDefault();

    }


  }

  sanitizePersian(e: any) {
    const value = e.target.value;
    e.target.value = value.replace(/[^\u0600-\u06FF\s]/g, '');

  }

  buildVehicleNo(response) {

    const objVehicleNo = response.strVehicleNo.split(' ');

    this.mdl_Request.patchValue({

      plak4: objVehicleNo[4],

      plak3: objVehicleNo[2],

      plak2: objVehicleNo[1],

      plak1: objVehicleNo[0]

    })


  }

  updateRequest = async () => {

    if (this.mdl_Request.invalid) {

      const addressControl = this.mdl_Request.get('strAddress');
      const otherControlsInvalid = Object.keys(this.mdl_Request.controls)
        .filter(key => key !== 'strAddress')
        .some(key => this.mdl_Request.get(key)?.invalid);

      if (addressControl?.invalid && !otherControlsInvalid) {
        this._tooltip.showError('موقعیت را از روی نقشه انتخاب کنید');
        addressControl.markAsTouched();
        return;
      }

      this._other.markAllAsTouched(this.mdl_Request);

      return this._tooltip.showError('فیلدهای ضروری را وارد کنید');

    }

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            let model = this._other.stringNumberToNumber(this.mdl_Request.value);

            model.strVehicleNo = `${model.plak1} ${model.plak2} ${model.plak3} | ${model.plak4}`;

            model.strSession = this._gurd.decrypt(localStorage.getItem('Session')!);

            model.iSystemUser = this._gurd.decrypt(localStorage.getItem('ID')!);

            model.strName = this.mdl_Request.getRawValue().strName;

            model.strFamily = this.mdl_Request.getRawValue().strFamily;

            delete model.strLicenseImage;

            this._other.Showspinner();

            let res = JSON.parse((await axios.post(`Preregistration_Update4Manager`, model)).data.toString());

            this._other.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._other.removeLocalStorage();

              this._router.navigate(['login'], { queryParams: { error: 'x12z[1110' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess('با موفقیت ویرایش شد');

            $("#editRequest_Modal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  accessibility(...array: string[]): boolean {

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

}
